import {useTranslation} from 'react-i18next';

import {Box} from '@mui/material';

import {WorkforceProfileWizardSkillsEditor} from '../WorkforceProfileWizardSkillsEditor';

import {InfoBanner} from '../../../../../../components/InfoBanner/InfoBanner';
import type {WorkforceProfileExtractedSkill} from '../../../types/workforceProfileDetailsTypes';

export interface Props {
  rows: WorkforceProfileExtractedSkill[];
  suggested: boolean;
  onRowsChange: (rows: WorkforceProfileExtractedSkill[]) => void;
}

export const WorkforceProfileWizardKnowledgeStep = ({rows, suggested, onRowsChange}: Props) => {
  const {t} = useTranslation('translation', {
    keyPrefix: 'workforceProfilesPage.wizard.sections.knowledge',
  });

  return (
    <Box>
      <InfoBanner text={t('guidance')} sx={{mb: 2}} />
      <WorkforceProfileWizardSkillsEditor
        title={t('label')}
        rows={rows}
        suggested={suggested}
        onChange={onRowsChange}
      />
    </Box>
  );
};
